module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAABZklEQVQ4jY3TPUjWURTH8c//b2KYi4MvPGJDCDVICM8gOLg0SSFlS4NFY0vg4GBD0eQgCIKDiIvg0FDQFA5BmZNLSBC9QERBS1vPUKEYNtzz4PXhedDfdO4953vvueecW1SrVZnacRc3MIou/MBrLONdHlxk8AU8x2XNdYhFzOEflOHox5sAv+A2etERe4s4wCxWGm9+hpvYwQR+Nbl5HJvoxDW8KOPkKfzGrRYgbONB2A/raV9HgSf43gKsaxU1qZiDJYbCsXMCCHt4G/alEvuxKE4By+I7SuzG4uopwC4pZXhfSpXexySqrajQPXRjC99K/JSmp8Q6zrYAh/A47HmOhuQRPmEYC03ATjzFOWzgZQ7/wXSkfx93MrBNauMIPodfDpNaMBP2Gq6EvSTVoyYNU60OnGlIbwXnpeHfxFdcjIym8CEPbqtUKo3veyW1ZAw90rhOx2HHVDT851x9GMBH/G0W8B/+vkRrutpfegAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/地图.png
// module id = lIPg
// module chunks = 1